/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { DialogTitle, DialogContent, Grid, IconButton, Button, TextField, styled, Rating, Dialog, Typography, Box,Link,
} from "@mui/material";
import en from "../../nls/en.json";
import Style from "../Styles/CssModulesGlobal.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import { role_name, isEmpty, showdate } from "../../utils/constants";
import { scheduledMeetingFeedback, feedbackReport, checkUsersMeetingFeedback } from "../../store/calendlySlice";
import CustomDialog from "../common/CustomDialog/CustomDialog";
import { setOpenPopup, setOpenPopupReport } from "../../store/documentSlice";
import SentimentSatisfiedAltOutlinedIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import SentimentNeutralOutlinedIcon from '@mui/icons-material/SentimentNeutralOutlined';
import WarningPopUp from "../common/WarningPopUp";
import PropTypes from 'prop-types';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const cssObject = {
  position: "absolute",
  right: 8,
  top: 8,
  color: "#1468A2",
};

/* eslint-disable-next-line */
const Feedbackmeetings = ({meetingData, defaultOpen = false}) => {

  const [openFeedbackPopup, setOpenFeedbackPopup] = useState(false);
  const [value, setValue] = useState(0);
  const [hover, setHover] = useState(5);
  const [reportPopup, setReportPopup] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const dispatch = useDispatch();
  const { savedAnswer, loggedInUserId } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
  const { openPopup, openPopupReport } = useSelector(({document})=>document);
  const { BASIC_INFORMATION } = savedAnswer;

  const [formData, setFormData] = useState({
    student_feedback: "",
    student_rating: 0,
    mentor_rating: 0,
    mentor_note_student: "",
    mentor_note_admin: ""
  });

  const [formDataReport, setFormDataReport] = useState({
    comment: ""
  });

  const handleDialogOpen = (message) => {
    setDialogMessage(message);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFormChangeForReport = (e) => {
    const {name, value} = e.target;
    setFormDataReport(prevState => ({
      ...prevState,
       [name]:value
    })); 
  }
  
  const { student_feedback, student_rating, mentor_note_student, mentor_note_admin } = formData;
  
  const isStudent = BASIC_INFORMATION?.role_name === role_name.STUDENT;
  const isMentor = BASIC_INFORMATION?.role_name === role_name.MENTOR;

  const icons = {
    "0.5": <SentimentDissatisfiedOutlinedIcon />,
    "1": <SentimentDissatisfiedOutlinedIcon />,
    "1.5": <SentimentDissatisfiedOutlinedIcon />,
    "2": <SentimentDissatisfiedOutlinedIcon />,
    "2.5": <SentimentDissatisfiedOutlinedIcon />,
    "3": <SentimentNeutralOutlinedIcon />,
    "3.5": <SentimentSatisfiedAltOutlinedIcon />,
    "4": <SentimentSatisfiedAltOutlinedIcon />,
    "4.5": <SentimentSatisfiedAltOutlinedIcon />,
    "5": <SentimentSatisfiedAltOutlinedIcon />,
  }

  const btnStyle = { fontSize: "14px", padding: "10px 20px", marginLeft:"8px", marginTop:"8px" };

  const handleCancelFeedbackPopup = () => {
    setFormData({});
    setOpenFeedbackPopup(false);
  };

  const handleCancelFeedbackSubmit = () => {
    setOpenFeedbackPopup(false);
    setFormDataReport({});
  };

  const handleOpenFeedback = () => {
    setFormData({});
    setOpenFeedbackPopup(true);
  };

  const handleClose = () => {
    setFormData({});
    dispatch(setOpenPopup(false));
    dispatch(checkUsersMeetingFeedback());
  };
  
  const handleCloseReport = () => {
    setFormData({});
    dispatch(setOpenPopupReport(false));
  };
  function getIcons(value) {
    return `${value} Star${value !== 1 ? "s" : ""}, ${icons[value]}`;
  }
  
  const handleReportPopup = () => { 
   setFormDataReport({});
   setReportPopup(true);
  }
  const handleCloseReportPopup = () => {
    setFormDataReport({});
    setReportPopup(false)
  };
  
 const handleFeedbackSubmit = () => {
  if (isStudent) {
    if (isEmpty(student_feedback)) {
      handleDialogOpen("Please enter student feedback");
      return;
    }
    if (isEmpty(student_rating)) {
      handleDialogOpen("Please select mentor rating");
      return;
    }
  } else if (isMentor) {
    if (isEmpty(mentor_note_student)) {
      handleDialogOpen("Please enter notes for student");
      return;
    }
    if (isEmpty(mentor_note_admin)) {
      handleDialogOpen("Please enter notes for admin");
      return;
    }
    if (isEmpty(student_rating)) {
      handleDialogOpen("Please select student rating");
      return;
    }
  }
  const payload = {
    meetings_booking_uuid: meetingData?.meeting_uuid,
    ...(isStudent
      ? { student_feedback, student_rating }
      : { mentor_rating: formData?.student_rating, mentor_note_student, mentor_note_admin }),
  };

  dispatch(scheduledMeetingFeedback(payload));
  setOpenFeedbackPopup(false);
};
  
  const handleSubmitReport = () => {
     const payload = isStudent ? {
      meetings_booking_uuid: meetingData?.meeting_uuid,
      flagging_user_id: loggedInUserId,
      flagged_user_id: meetingData?.mentor_user_id, 
      comment: formDataReport.comment,
     } : {
      meetings_booking_uuid: meetingData?.meeting_uuid,
      flagging_user_id: loggedInUserId,
      flagged_user_id: meetingData?.student_user_id, 
      meeting_continuation_flag: 1,
      comment: formDataReport.comment,
     }
     if(!isEmpty(formDataReport?.comment)){
      dispatch(feedbackReport(payload));
      setReportPopup(false);
     }  
  }

  useEffect(()=>{
    if(defaultOpen > 0){
      setOpenFeedbackPopup(defaultOpen)
    }
  },[defaultOpen]);

  const getMeetingsDetails = () => {
    return (
      <>
        <Typography sx={{
          fontSize: 20,
          fontWeight: 500,
          textAlign: "left"
        }}> Meeting Details </Typography>
        <Typography>Name: {meetingData?.name}</Typography>
        <Typography>Date: {showdate(meetingData?.from_date_time)}</Typography>
      </>
    )
  }

  return (
    <>
      {/* Feedfack ratings */}
      <Button 
        variant="outlined" 
        disabled={meetingData?.is_feedback_given} 
        onClick={handleOpenFeedback}
        sx={btnStyle} 
        size="medium"
        className={defaultOpen > 0 ? "hiddenCC": ""}
        >
       {en.SEND_FEEDBACK}
      </Button>

      <BootstrapDialog
        // onClose={handleCancelFeedbackSubmit}
        aria-labelledby="meeting-feedback-dialog-title"
        open={openFeedbackPopup}
        PaperProps={{ style: { borderRadius: "8px" } }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{ m: 0, p: 2, backgroundColor: "#66666626" }}
          id="meeting-feedback-dialog-title"
        >
        {en.MEETING_FEEDBACK}
        </DialogTitle>
        <IconButton
          className={defaultOpen > 0 ? "hiddenCC" : ""}
          aria-label="close"
          onClick={handleCancelFeedbackPopup}
          sx={cssObject}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        {meetingData?.name && getMeetingsDetails()}
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                w: 1,
                mb: 1,
                px: 8,
              }}
            >
              {value !== null ? (
                <Box className={Style.iconWrapper}>
                  {icons[hover !== -1 ? hover : value]}{" "}
                </Box>
              ) :
              <Box className={Style.iconWrapper}>
               <SentimentSatisfiedAltOutlinedIcon />   
              </Box> 
              }
            </Box>
            <Typography
              gutterBottom
              sx={{
                fontSize: 20,
                fontWeight: 500,
                textAlign: "center",
                mb: 2,
              }}
            >
              {en.MEETING_EXPERIENCE_MSG}
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "center", w: 1, mb: 1 }}
            >
              <Rating
                value={formData?.student_rating}
                name="student_rating"
                precision={0.5}
                size="large"
                getIcons={getIcons}
                  onChange={(event, newValue) => {
                    setValue(newValue)
                    handleFormChange(event)
                  }}
                onChangeActive={(event, newHover) => {
                  setHover(newHover);
                }}
              />
            </Box>
            {isStudent && (
              <Grid container spacing={2} sx={{ mt: 2, mb: 4 }}>
                <Grid
                  item
                  xs={12}
                  md={12}
                  justifyContent="center"
                  display="flex"
                >
                  <TextField
                    id="meetingFeedback"
                    placeholder="Write here..."
                    variant="outlined"
                    fullWidth
                    name="student_feedback"
                    value={formData.student_feedback}
                    multiline
                    rows={3}
                    onChange={handleFormChange}
                    InputProps={{
                      sx: { fontSize: "14px" },
                    }}
                    className={Style.feedbackInput}
                  />
                </Grid>
                {/* {formData?.student_feedback?.length > 100 && (
                <Typography variant="body2" sx={{marginLeft:12}} color="error">{en.FEEDBACK_ERR_MSG}</Typography>
                )} */}
              </Grid>
            )}
            {isMentor && (
              <Grid container spacing={2} sx={{ mt: 2, mb: 4 }}>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{ fontSize: 12, fontWeight: 500, color: "#666" }}
                  >
                 {en.NOTES_FOR_STUDENT}
                  </Typography>
                  <TextField
                    id="notesStudent"
                    placeholder="Write here..."
                    variant="outlined"
                    fullWidth
                    name="mentor_note_student"
                    value={formData.mentor_note_student}
                    onChange={handleFormChange}
                    multiline
                    rows={3}
                    InputProps={{
                      sx: { fontSize: "14px" },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{ fontSize: 12, fontWeight: 500, color: "#666" }}
                  >
                   {en.NOTE_FOR_ADMIN}
                  </Typography>
                  <TextField
                    id="notesAdmin"
                    placeholder="Write here..."
                    variant="outlined"
                    fullWidth
                    name="mentor_note_admin"
                    value={formData?.mentor_note_admin}
                    multiline
                    rows={3}
                    onChange={handleFormChange}
                    InputProps={{
                      sx: { fontSize: "14px" },
                    }}
                  />
                </Grid>
              </Grid>
            )}
            <Box sx={{ display: "flex", justifyContent: "center", w: 1, mb: 4 }}>
              <Button variant="contained" onClick={handleFeedbackSubmit}>
                {en.SUBMIT}
              </Button>
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 600, mb: 1, fontSize: 14 }}>
               <i>{en.CONCERN_MSG}</i>
              </Typography>
              <Button
                variant="outlined"
                sx={{ padding: "4px 12px !important" }}
                onClick={handleReportPopup}
              >
               {isStudent ? en.REPORT_MENTOR : en.REPORT_STUDENT}
              </Button>
        <BootstrapDialog
        onClose={handleCloseReportPopup}
        aria-labelledby="meeting-feedback-dialog-title"
        open={reportPopup}
        PaperProps={{ style: { borderRadius: "8px" } }}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle
          sx={{ m: 0, p: 2, backgroundColor: "#66666626" }}
          id="meeting-feedback-dialog-title"
        >
        {isStudent ? en.REPORT_MENTOR :  en.REPORT_STUDENT}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseReportPopup}
          sx={cssObject}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        <Typography
              gutterBottom
              sx={{
                fontSize: 16,
                fontWeight: 500,
                mb: 2,
              }}
            >
              {isMentor ? en.HEAD_CONTENT_MENTOR : en.HEAD_CONTENT_STUDENT}
            </Typography> 
          <Box>
            <Typography
              gutterBottom
              sx={{
                fontSize: 16,
                fontWeight: 500,
                mb: 2,
              }}
            >
              {en.REPORT_MENTOR_MSG}
            </Typography>           
            
              <Grid container spacing={2} sx={{ mb: 4 }}>
                <Grid
                  item
                  xs={12}
                  md={12}
                  justifyContent="center"
                  display="flex"
                >
                  <TextField
                    id="comment"
                    placeholder="Write here…​"
                    variant="outlined"
                    fullWidth
                    name="comment"
                    value={formDataReport.comment}
                    multiline
                    rows={3}
                    onChange={handleFormChangeForReport}
                    InputProps={{
                      sx: { fontSize: "14px" },
                    }}
                  />
                </Grid>
                {formDataReport?.comment?.length > 250 ? (
                <Typography variant="body2" sx={{marginLeft:2}} color="error">{en.COMMENT_ERR}</Typography>
                ) : isEmpty(formDataReport?.comment) && <Typography variant="body2" sx={{marginLeft:2}} color="error">{en.REASON_ERROR_MSG}</Typography>}
              </Grid>
       
            <Box sx={{ display: "flex", justifyContent: "center", w: 1, mb: 1 }}>
              <Button variant="contained" sx={{height:36}} onClick={handleSubmitReport}>
                {en.SEND}
              </Button>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", w: 1 }}>
            <Link componet="button" onClick={handleCloseReportPopup} style={{ cursor: 'pointer' }}>{en.BACK}</Link>
            </Box>
          </Box>
        </DialogContent>
      </BootstrapDialog>
            </Box>
          </Box>
        </DialogContent>
      </BootstrapDialog>
      <CustomDialog 
         openPopup={openPopup} 
         handleClose={handleClose}
         messageSuccess={en.SUCCESS_MSG}
         messageReview={en.FEEDBACK_MEETING_SUCCESS_MSG}
         iconSuccess      
        />
        <CustomDialog 
         openPopup={openPopupReport} 
         handleClose={handleCloseReport}
         messageSuccess={en.SUCCESS_MSG}
         messageReview={isMentor ? en.FLAG_SUCCESS_MSG_MENTOR : en.FLAG_SUCCESS_MSG_STUDENT} 
         iconChange     
        />
        <WarningPopUp
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        dialogMessage={dialogMessage}
      />
    </>
  );
};

Feedbackmeetings.propTypes = {
  meetingData: PropTypes.shape({
    meeting_uuid: PropTypes.string.isRequired,
    mentor_user_id: PropTypes.string.isRequired,
    student_user_id: PropTypes.string.isRequired,
    is_feedback_given: PropTypes.bool.isRequired
  }).isRequired,
};

export default Feedbackmeetings;
